const [ w, d, l, content ] = [ window, document, location, 'service' ]

const getArticles = $.getJSON('/asset/api/getArticles/',{content})
const getCategories = $.getJSON('/asset/api/getCategories/',{content})
const getCatDesc = $.getJSON('/asset/json/service-cat-desc.json')

const init = () => {
  if( w.query_string('cat') ) {
    $('.element_list .list_title1').remove()
  }
  $('.contents .wrapLink','.element_list').each( (i,obj) => {
    let href = obj.getAttribute('href')
    let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
    let is_new = obj.querySelectorAll('span.new').length > 0 ? true: false
    let catObj = obj.querySelector('.catetitle a')
    let cat = catObj? catObj.innerText : ''
    let title = obj.querySelector('h5 > a').getAttribute('title')
    let desc = obj.querySelector('p.catch').innerText
    let $item = $(`
      <a href="${href}" class="${content}-item">
        <figure class="${content}-item__img">
          <div class="${content}-item__img-cover" style="background-image:url(${thumb})"><img src="${thumb}" alt="${title}" width=""></div>
        </figure>
        <div class="${content}-item__body">
          <h4 class="subject">
            <span>${title}</span>
            <svg class="icon" width="16" height="16"><use xlink:href="/asset/svg/sprite.symbol.svg#icon-arrow-right-circle"></use></svg>
          </h4>
        </div>
      </a>`)
    $(obj).replaceWith( $item )
  })

  // グローバルメニューカレントクラス
  $.when(
    getArticles,
    w.load['header']
  ).then( articles => {
    let the_cat = 1
    let the_id = d.body.getAttribute('class').replace(/^.+is--article-([\d]+)(.+)?$/,'$1')
    let the_article = articles[0].filter( a => a.id == the_id )
    // 一覧ページの場合
    if( d.body.classList.contains('is--list') && w.query_string('cat') ) the_cat = w.query_string('cat')
    // 詳細ページの場合
    if( d.body.classList.contains('is--detail') ) the_cat = the_article[0].category
    $('.p-gnav__list','#header').currentMenu({
      url: `${l.pathname}?mode=list&cat=${the_cat}`
    })
  })

  // 一覧ページコンテンツヘッダー
  if( d.body.classList.contains('is--list') && w.query_string('cat') ) {
    $.ajaxSetup({ cache: false })
    $.when( getCategories, getCatDesc ).then( ( categories, catDescs ) => {
      let cat_id = w.query_string('cat')
      let the_cat = categories[0].filter( c => c.id == cat_id )
      let the_desc = catDescs[0].filter( c => c.id == cat_id )
      if( the_desc.length == 0 ) the_desc = catDescs[0].filter( c => c.id == 1 )
      $('.mainImg .mainImgInner').replaceWith(`
        <div class="mainImgInner"><!-- js:replaced start -->
          <h2><span>${the_cat[0].name}</span></h2>
          <p>${the_desc[0].body}</p>
        <!-- js:replaced end --></div>
      `)
      console.info('.mainImgInner is replaced by \'/asset/json/service-cat-desc.json\'')
    })
  }

  // 詳細書き換え
  if( d.body.classList.contains('is--detail') ){
    let the_id = document.body.getAttribute('class').replace(/^.+is--article-([\d]+)(.+)?$/,'$1')
    let codingPageArr = [1]
    const is_userEdit = () => codingPageArr.indexOf( parseInt( the_id ) ) == -1

    // 記事ヘッダー書き換え
    const replaceHead = title => {
      $('.element_detail .hs_entrytitle, .element_detail > .title').remove()
      $(`
        <div class="${content}-detailHead">
          <h2 class="${content}-detail-title">${title}</h2>
        </div>
      `).prependTo('#main')
    }
    if( is_userEdit() ) replaceHead( d.querySelector('.hs_entrytitle').innerText )

    // 記事フッターナビ挿入
    const insertNav = id => {
      let $nav = $(`<nav/>`, { class: 'service-nav' }).insertAfter('#container')
      let $nav_list = $(`<div/>`, { class: 'service-nav__inner' }).appendTo( $nav )
      $.when(
        getArticles,
        getCategories
      ).then( ( articles, categories ) => {
        let the_article = articles[0].filter( a => a.id == id )[0]
        let related = articles[0].filter( a => a.category == the_article.category )
        let the_category = categories[0].filter( c => c.id == the_article.category )[0]
        let $btn = $(`
          <div class="service-nav__btnwrap">
            <a href="/service/?mode=list&amp;cat=${ the_category.id }" class="button">
              <span>${ the_category.name }一覧</span>
              <svg class="icon" width="16" height="16"><use xlink:href="/asset/svg/sprite.symbol.svg#icon-arrow-right-circle"></use></svg>
            </a>
          </div>
        `).prependTo( $nav )
        $.each( related, ( i, obj ) => {
          let is_current = () => (the_id == obj.id)? ' current': ''
          $nav_list.append(`<a href="${obj.href}" class="button-text${is_current()}">${obj.title.str_truncate(10)}</a>`)
        })
      })
    }
    insertNav( the_id )

    // ユーザー更新ページ　クラス付与
    if( is_userEdit() )  $('body').addClass('is-useredit')
  }
}

export default function SERVICE () {
  $( init )
}